import { useQuery } from "@tanstack/react-query";
import { graphQLClient } from "@/graphqlClient";
import { GET_CONTENT_SUBSCRIPTIONS_FOR_ENTITY } from "@/api/queries";

interface ContentSubscription {
  id: string;
  parentID: string;
  featureIDs?: string[] | null;
}

interface GetContentSubscriptionsForEntityResponse {
  getContentSubscriptionsForEntity: ContentSubscription[];
}

export const useGetClimberContentSubscriptions = (
  climberId: string,
  enabled = true,
) => {
  return useQuery<ContentSubscription[]>({
    queryKey: ["contentSubscriptionsForEntity", climberId],
    queryFn: async () => {
      if (!climberId) return [];
      const res =
        await graphQLClient.request<GetContentSubscriptionsForEntityResponse>(
          GET_CONTENT_SUBSCRIPTIONS_FOR_ENTITY,
          { parentID: climberId },
        );
      return res?.getContentSubscriptionsForEntity ?? [];
    },
    enabled: enabled && !!climberId,
  });
};
